import { render, staticRenderFns } from "./Scorers.vue?vue&type=template&id=2b748cc6&scoped=true&"
import script from "./Scorers.vue?vue&type=script&lang=js&"
export * from "./Scorers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b748cc6",
  null
  
)

export default component.exports